export default __webpack_public_path__ + "static/media/sounds/spelling_replay_instruction.mp3";